// extracted by mini-css-extract-plugin
module.exports = {"myAccountPage":"MyAccount_myAccountPage__29YWw","fadeIn":"MyAccount_fadeIn__2nd5X","scaleXin":"MyAccount_scaleXin__3ToHj"};